import { render, staticRenderFns } from "./Finished.vue?vue&type=template&id=33fcc656&scoped=true&"
import script from "./Finished.vue?vue&type=script&lang=js&"
export * from "./Finished.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33fcc656",
  null
  
)

export default component.exports